export interface BoxSize {
  width: number;
  height: number;
}

/**
 * The picture a video draws inside its element box: the largest box of the
 * video's aspect ratio that fits, as `object-fit: contain` draws it.
 *
 * The box should be the element's exact layout size. A size rounded to whole
 * pixels (clientWidth / clientHeight) makes a picture up to a pixel off the one
 * on screen, which left a sliver of the video outside the pause overlay.
 */
export function containedPictureSize(box: BoxSize, aspectRatio: number): BoxSize {
  if (!(aspectRatio > 0) || !Number.isFinite(aspectRatio)) {
    throw new TypeError(`aspectRatio must be a positive number, got ${aspectRatio}`);
  }
  const widthAtFullHeight = box.height * aspectRatio;
  return widthAtFullHeight > box.width
    ? { width: box.width, height: box.width / aspectRatio }
    : { width: widthAtFullHeight, height: box.height };
}

/** An element's layout size with its fractions kept. */
export function exactSizeOf(element: Element): BoxSize {
  const { width, height } = element.getBoundingClientRect();
  return { width, height };
}
